
import { formatNumber, getAvailableCredit } from "@/static/utils";
import LoanDetails from "./LoanDetails.vue";
import LoanList from "./LoanList.vue";
import { LoanStatus } from "@/models/Loan";
import Notify from 'quasar/src/plugins/Notify.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';;
import { ref } from "@vue/reactivity";
import { useLoan } from "@/hooks/useLoan";
import { useRouter } from "vue-router";
export default {
  components: {
    LoanDetails,
    LoanList,
  },
  setup() {
    const router = useRouter();
    const getCredit = () => {
      router.push("./get-credit");
    };
    const { payLoanEMI, loanData } = useLoan({});
    const selectedLoan = ref();
    const availableCredit = getAvailableCredit(loanData.value);
    const showLoan = ref(false);
    const dialogRef = ref<QDialog>();
    const handleLoanClick = (loan) => {
      selectedLoan.value = loan;
      showLoan.value = true;
    };
    const payLoan = () =>
      payLoanEMI(selectedLoan.value.id).then(() => {
        dialogRef.value?.hide();
        Notify.create({
          message: "EMI Paid Successfully!",
          color: "primary",
          icon: "check_circle",
        });
      });
    return {
      availableCredit,
      dialogRef,
      formatNumber,
      getCredit,
      handleLoanClick,
      loanData,
      LoanStatus,
      payLoan,
      selectedLoan,
      showLoan,
    };
  },
};
